import { GuideTourValidationError } from './errors'

export const assertNonEmptyString = (
  value: string,
  fieldName: string
): void => {
  if (!value.trim()) {
    throw new GuideTourValidationError(
      `${fieldName} must be a non-empty string`
    )
  }
}

export const assertUniqueValues = (
  values: string[],
  fieldName: string
): void => {
  const seen = new Set<string>()

  for (const value of values) {
    if (seen.has(value)) {
      throw new GuideTourValidationError(
        `${fieldName} must be unique within the tour`
      )
    }

    seen.add(value)
  }
}
